var render = function render(){var _vm=this,_c=_vm._self._c;return _c('form',{staticClass:"form-container",attrs:{"disabled":_vm.disabled},on:{"submit":function($event){$event.preventDefault();return _vm.$emit('submit')}}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }